var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakeFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 122,
    viewBox: "0 0 400 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9176 0C27.2737 -2.94124e-06 2.94135e-06 27.2737 0 60.9176C-2.94112e-06 94.5614 27.2737 121.835 60.9176 121.835C94.5614 121.835 121.835 94.5614 121.835 60.9176C121.835 27.2737 94.5614 2.94124e-06 60.9176 0ZM60.9179 103.56C84.4686 103.56 103.56 84.4683 103.56 60.9176C103.56 37.3669 84.4686 18.2753 60.9179 18.2753C37.3672 18.2753 18.2756 37.3669 18.2756 60.9176C18.2756 84.4683 37.3672 103.56 60.9179 103.56ZM60.9179 109.652C87.8329 109.652 109.652 87.8327 109.652 60.9176C109.652 34.0026 87.8329 12.1836 60.9179 12.1836C34.0028 12.1836 12.1838 34.0026 12.1838 60.9176C12.1838 87.8327 34.0028 109.652 60.9179 109.652ZM49.2875 44.7644C48.0386 43.5154 46.0136 43.5154 44.7646 44.7644C43.5157 46.0134 43.5157 48.0383 44.7647 49.2873L56.395 60.9176L44.7647 72.5479C43.5157 73.7969 43.5157 75.8219 44.7647 77.0708C46.0136 78.3198 48.0386 78.3198 49.2876 77.0708L60.9179 65.4405L72.5482 77.0708C73.7971 78.3198 75.8221 78.3198 77.0711 77.0708C78.32 75.8219 78.32 73.7969 77.0711 72.5479L65.4408 60.9176L77.0711 49.2873C78.3201 48.0384 78.32 46.0134 77.0711 44.7644C75.8221 43.5155 73.7971 43.5154 72.5482 44.7644L60.9179 56.3947L49.2875 44.7644Z",
    fill: "#88BB5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.432 106.606V24.6281L184.472 75.9294H173.644L159.685 24.6281V106.606H149.248V15.2294H167.643L179.515 61.9619L191.256 15.2294H209.26V106.606H198.432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.926 23.8449L241.359 73.7102H262.624L251.926 23.8449ZM269.669 106.606L264.711 83.5006H239.271L234.183 106.606H222.572L244.62 15.2294H259.623L281.28 106.606H269.669Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.883 106.606L311.531 64.7031L306.834 72.5354V106.606H295.484V15.2294H306.834V55.3044L331.23 15.2294H343.363L318.576 55.1739L344.668 106.606H331.883Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.209 106.606V15.2294H400V24.7586H368.559V54.6517H396.738V64.181H368.559V97.0765H400V106.606H357.209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeFull);
export default __webpack_public_path__ + "static/media/make-full.63ac369eb567ce5348b14b4821b6140f.svg";
export { ForwardRef as ReactComponent };